import { makeStyles } from "@material-ui/core";
import { colors } from "../../shared/utils/colors";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginTop: 16,
    paddingTop: 16,
    borderTop: "1px solid #d9d9d9",
    width: "100%",
    boxSizing: "border-box",
    flex: 1,
  },
  title: { color: colors.blueDarken },
  mensaje: { color: colors.greyFont },
  productos: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    columnGap: 24,
    rowGap: 16,
    width: "100%",
  },
  producto: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  productoTitle: {
    color: colors.blueDarken,
    marginBottom: 4,
  },
  label: {
    marginTop: 8,
    color: colors.blueDarken,
  },
  errorBox: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  errorText: { color: colors.greyFont },
  acciones: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginTop: "auto",
  },
  cancelar: { color: colors.blueDarken, textTransform: "none" },
  button: {
    color: colors.white,
    background: colors.blueDarken,
    borderRadius: 19,
    textTransform: "uppercase",
    padding: "6px 24px",
    "&:hover": { background: colors.blueDarken },
  },
});

export default useStyles;
